<template lang="pug" src="./reports.pug"> </template>

<script>
    import uuid from 'uuid';
    import {mapGetters, mapState} from 'vuex';
    import {transliterate} from 'transliteration';
    import {downloadBlob} from '@/utils/helpers';
    import {loadReportWaitTime} from '../../../../config';
    import request from '@/utils/request';

    export default {
    data: () => ({
        anotherReportKey: uuid(),
        filters: {
            chosenBrand: null,
            chosenCompany: null,
            query: null,
            startDate: new Date().addDays(-1).format('{yyyy}-{MM}-{dd}'),
            endDate: new Date().addDays(1).format('{yyyy}-{MM}-{dd}'),
            startTime: '00:00',
            endTime: '23:59'
        },
        reportData: {
            header: null,
            data: null,
            total: null
        },
        startDateModal: false,
        endDateModal: false,
        startTimeModal: false,
        endTimeModal: false,
        loaded: true,
        processing: false,
        pagination: {
            page: 1,
            totalPages: 1
        }
    }),
    computed: {
        ...mapGetters(['operator', 'userBrandId', 'roleName']),
        ...mapState({
            userReports: state => state.reports.userReports,
            reportsCategories: function(state) {
                const categories = state.reports.categories;
                const anotherTranslation = this.$vuetify.lang.t('$vuetify.pages.Reports.another');

                return categories.map(it => ({
                    value: it || this.anotherReportKey,
                    title: it || anotherTranslation
                }));
            },
            brands: state => state.data.brands,
            companies: state => state.data.companies
        }),
        headers() {
            if (!this.reportData.header) {
                return [];
            }

            return this.reportData.header.map(header => ({
                text: header,
                sortable: false,
                align: 'center'
            }));
        },
        report() {
            return this.userReports.find(report => report.id == this.reportId);
        },
        searchCategory() {
            return this.reportCategory !== this.anotherReportKey
                ? this.reportCategory
                : null;
        },
        showFilters() {
            return this.report && (
                this.report.useDates || this.report.useQuery ||
                this.report.useTimes || this.showBrands || this.showCompanies
            );
        },
        showBrands() {
            return !this.userBrandId && this.report.useBrand;
        },
        showCompanies() {
            return !this.operator.companyId && this.report.useCompany;
        },
        showTable() {
            return this.reportData.header && this.reportData.data;
        },
        reportCategory: {
            get() {
                return this.$store.state.reports.filters.reportCategory;
            },
            set(val) {
                this.$store.commit('reports/SET_REPORT_CATEGORY', val);
            }
        },
        reportId: {
            get() {
                return this.$store.state.reports.filters.reportId;
            },
            set(val) {
                this.$store.commit('reports/SET_REPORT_ID', val);
            }
        }
    },
    created() {
        this.$store.dispatch('reports/getReportsCategories').then(() => {
            this.loaded = false;
        });

        this.$store.dispatch('data/getBrands');

        if (!this.operator.companyId) {
            this.$store.dispatch('data/getCompanies');
        }
    },
    methods: {
        changeCategory() {
            this.loadUserReports();

            this.reportId = null;
        },

        changeReport(reportId) {
            this.reportId = reportId;
        },

        loadUserReports() {
            this.$store.dispatch('reports/getUserReports', {
                category: this.searchCategory
            });
        },

        async loadReport(page = 1, exel) {
            this.loaded = true;
            this.clearReportForm();

            if (this.processing) return;

            this.processing = true;

            await request({
                url: `/admin/reports/${this.report.id}/data`,
                method: 'get',
                responseType: exel ? 'blob' : 'json',
                timeout: loadReportWaitTime * 1000,
                params: {
                    page, exel,
                    q: this.filters.query,
                    ...Object.select(this.filters, ['startDate', 'endDate',
                        'startTime', 'endTime', 'chosenBrand']),
                    chosenCompany:  this.operator.companyId || this.filters.chosenCompany
                }
            }).then(res => {
                    if (res.data.error) {
                        return this.$store.dispatch('alert/addMessage', {
                            type: 'error',
                            message: res.data.error,
                            locale: false
                        });
                    }

                    if (exel) {
                        const reportName = this.report.name ? `${transliterate(this.report.name)}_${uuid()}` : uuid();

                        return downloadBlob(res.data, `Report_${reportName}.xlsx`);
                    }

                    this.reportData = Object.assign({}, this.reportData, res.data);

                    this.pagination = {
                        page: res.data.page || 1,
                        totalPages: res.data.totalPages || 1
                    };
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    this.$store.dispatch('alert/addMessage', {
                        message: error.response.data.error
                    });
                }
            }).finally(() => {
                this.loaded = false;
                this.processing = false;
            });
        },

        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadReport(page);
            }
        },

        clearReportForm: function() {
            this.reportData = {
                header: null,
                data: null,
                total: null
            };
        },

        timeChange(value, type) {
            if (!value) {
                const defaults = {
                    startTime: '00:00',
                    endTime: '23:59'
                };

                this.filters[type] = defaults[type];
            }
        }
    }
};
</script>
